import React from "react";
import { AuthConsumer } from "../../providers/authProvider";
import { LoadingScreen } from "../common";

export const LogoutCallback = () => (
  <AuthConsumer>
    {({ signoutRedirectCallback }) => {
      signoutRedirectCallback();
      return <LoadingScreen />;
    }}
  </AuthConsumer>
);
